import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-terms-of-service',
  standalone: true,
  imports: [RouterLink, TranslatePipe],
  templateUrl: './terms-of-service.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./legal-page.css'],
})
export class TermsOfServiceComponent {}
